module.exports = __webpack_public_path__ + "img/project-manage.94887eb2.svg";